<template lang='pug'>
.fpui-package-editor-general
  .new-container(v-show="isNew")
    .row
      .col-xs-4
        label {{ 'fpStore.package.editor.general.organization'|translate }} *
      .col-xs-8
        fpui-input-select(
          :error='errors.owner',
          id='store-owner',
          color='blue',
          :value='item.owner',
          :placeholder="'fpStore.package.editor.general.organization.placeholder' | translate"
          @input='update("owner", $event)'
          :options='organizations'
        )
      .clearfix
    .row
      .col-xs-4
        label {{ 'fpStore.package.editor.general.name'|translate }} *
      .col-xs-8
        fpui-input-text(
          :error='errors.name',
          color='blue',
          :value='item.name',
          @input='updateName'
        )
      .clearfix
  .edit-container(v-show='!isNew')
    .row
      .col-xs-4
        label {{ 'fpStore.package.editor.general.organization'|translate }}
      .col-xs-8
        fpui-input-text(color='blue', :value='organizationName', disabled)
      .clearfix
    .row
      .col-xs-4
        label {{ 'fpStore.package.editor.general.name'|translate }}
      .col-xs-8
        fpui-input-text(color='blue', :value='item.name', disabled)
      .clearfix
  .row
    .col-xs-4
      label
        span {{ 'fpStore.package.editor.general.hidden'|translate }}
        fpui-helper(:text="'fpStore.package.editor.general.hidden.helper'|translate")
    .col-xs-8
      fpui-input-toggle(
        :value='item.hidden',
        :labels="{ checked: 'On', unchecked: 'Off' }"
        @input="update('hidden', $event)"
      )
  .row
    .col-xs-4
      label {{ 'fpStore.package.editor.general.category'|translate }}
    .col-xs-8
      fpui-input-text(color='blue', :value='item.category', @input="update('category', $event)")
    .clearfix
  .row
    .col-xs-4
      label {{ 'fpStore.package.editor.general.image'|translate }}
    .col-xs-8.package-image
      fpui-input-image(:value='item.image', @input='update("image", $event)')
    .clearfix
  .previews
    label {{ 'fpStore.package.editor.general.previews'|translate }}
      fpui-helper(:text="'fpStore.package.editor.general.previews.helper'|translate")
      fpui-button.pull-right(
        color="blue",
        unbordered,
        reverse,
        icon="fpui fpui-plus",
        @click="addPreview"
      )
        | {{ 'fpStore.package.editor.general.previews.add'|translate }}
    .row
      .preview(:key='index', v-for="preview, index in item.preview")
        fpui-input-image(
          :value='item.preview[index]',
          @input='updatePreview(index, $event)'
          :id='`item-preview-${index}`'
        )
        fpui-button(color="red",unbordered,reverse,icon="fpui fpui-trash",@click="removePreview(index)")
    .clearfix
</template>

<script>
import slugify from 'slugify'

export default {
  props: {
    isNew: { type: Boolean, default: false },
    item: { type: Object, required: true },
    errors: { type: Object }
  },
  data () {
    return {
      organizations: []
    }
  },
  computed: {
    organizationName () {
      let orga = this.organizations.find(orga => orga.value === this.item.owner)
      if (orga) return orga.label
      return ''
    }
  },
  mounted () {
    this.$api.king.organizations()
      .then(organizations => {
        this.organizations.splice(0, this.organizations.length)
        organizations.forEach(orga => {
          this.organizations.push({
            label: orga.name,
            value: orga.id
          })
        })
      })
  },
  methods: {
    update (key, value) {
      let item = {...this.item}
      this.$set(item, key, value)
      this.$emit('input', item)
    },
    updateName (value) {
      this.update('id', slugify(value).toLowerCase())
      this.update('name', value)
    },
    addPreview () {
      let preview = (this.item.preview && [...this.item.preview]) || []
      preview.push('')
      this.update('preview', preview)
    },
    updatePreview (index, value) {
      let preview = this.item.preview && [...this.item.preview]
      if (!preview || preview.length === 0) return
      this.$set(preview, index, value)
      this.update('preview', preview)
    },
    removePreview (index) {
      let preview = this.item.preview && [...this.item.preview]
      preview.splice(index, 1)
      this.update('preview', preview)
    }
  }
}
</script>

<style lang='less'>
  .fpui-package-editor-general {
    .row {
      padding-top: 10px;
      padding-bottom: 10px;
      .col-xs-4, .col-xs-8 {
        padding: 0;
      }
    }
    .fpui-input-image {
      width: 180px;
      background: white;
      height: 120px;
      position: relative;
      img {
        position: absolute;
        left: 50%;
        top: 50%;
        transform:translate(-50%, -50%);
      }
    }
    .previews {
      .preview {
        padding: 5px 5px;
        position: relative;
        display: inline-block;
        .fpui-input-image {
          width: 180px;
        }
        .fpui-button {
          position: absolute;
          top: 0;
          right: 0;
        }
      }
    }
    .package-image {
      height: 120px;
    }
    .fpui-input-toggle {
      line-height: 35px;
    }
  }
</style>
